import React from "react";
import PropTypes from "prop-types";
import { useTranslation, Trans } from "react-i18next";
// core imports
import { SFStack } from "../../../components/grid";
import {
  SFInfoIconFilled
} from "../../../components/icons";
import getStyled from "../../../hooks/getStyled";
import SFTypography from "../../../components/typography";

const { styled } = getStyled();

const StyledOffset = styled("div")(({ theme }) => ({
  width: 18,
}));

const RowValuesPercentageLabel = ({ percentage }) => {
  const { t } = useTranslation();
  let label;

  if (percentage === 0) {
    label = <Trans i18nKey={"fileUploadWizard.fileMapping.allRowsHaveValueLabel"} />;
  } else {
    label = (
      <Trans
        i18nKey={"fileUploadWizard.fileMapping.valueRowsPercentageLabel"}
        values={{
          percentage: Math.round(percentage),
        }}
      />
    );
  }
  return (
    <>
      <SFStack direction="row" alignItems="center" spacing={2}>
        <SFInfoIconFilled size="small" />
        <SFTypography variant="body1bold">{label}</SFTypography>
      </SFStack>
      {percentage !== 0 && (
        <SFStack direction="row" alignItems="center" spacing={2}>
          <StyledOffset></StyledOffset>
          <SFTypography variant="body2bold">
            {t("fileUploadWizard.fileMapping.correctMissingRowValuesLabel")}
          </SFTypography>
        </SFStack>
      )}
    </>
  );
};

RowValuesPercentageLabel.propTypes = {
  percentage: PropTypes.number.isRequired,
};

export default RowValuesPercentageLabel;
